import styled from '@emotion/styled'
import { Image } from 'components/Image'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SPhotoInProgress = styled.div<{ isInProgress?: boolean }>`
  position: relative;
  background: black;
  ${({ isInProgress }) =>
    isInProgress
      ? `
        & > img {
          opacity: 0.4;
        }
      `
      : `
        & > div {
          display: none;
        }
  `}
`

export const SPhoto = styled(Image)`
  position: absolute;
  width: 100%;
  height: 100%;
`

export const SImageTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 30%;
  @media ${BREAKPOINTS.MD.max} {
    padding: 25%;
  }
  text-align: center;
  align-items: center;
  justify-content: center;
  & > div {
    margin-bottom: ${pxToRem(12)}rem;
  }
  & > p {
    color: white;
    font-weight: bold;
  }
`

export const SIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`
